import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBButton from '@/components/SBButton';


@Component({
})
export default class SBButtonSmallGray extends Mixins(SBButton) {

    @Prop({
        type: Boolean,
        default: false,
    })
    public hiddenArrow!: boolean;
}
